import { render, staticRenderFns } from "./AreaEmbargadaIbama.vue?vue&type=template&id=679b7f5e&lang=pug"
import script from "./AreaEmbargadaIbama.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaIbama.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports